module.exports = __webpack_public_path__ + "img/vertical_4_3_8019.b6e4cfb6.png";